import type { Wallet } from '@wallet-standard/base';

export const hasAllRequiredFeatures = (wallet: Wallet): boolean => {
  return Boolean(
    wallet.features?.['standard:events'] &&
      wallet.features?.['standard:connect'] &&
      wallet.features?.['solana:signTransaction'] &&
      wallet.features?.['solana:signMessage']
  );
};
